<!--
 * @Author: your name
 * @Date: 2021-03-31 17:22:29
 * @LastEditTime: 2021-04-13 15:33:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \IoT micro front-end\house-base-v2\src\views\personal-center\ModifyPhone.vue
-->
<template>
  <div class="modify-phone-container">
    <a-modal
      wrapClassName="modify-phone-modal"
      :visible="visible"
      :closable="true"
      @cancel="handleClose"
      okText="保存"
      cancelText="取消"
      :footer="null"
      :maskClosable="false"
    >
      <template #title>
        <a-row
          type="flex"
          justify="start"
          :gutter="20"
        >
          <a-col>
            <a-icon
              type="left"
              @click="handleCancel"
            />
          </a-col>
          <a-col>验证手机</a-col>
        </a-row>
      </template>
      <a-form-model
        class="modify-phone-form"
        ref="formRef"
        :model="form"
        :rules="rules"
        layout="vertical"
      >
        <a-form-model-item
          label="输入新手机号"
          prop="phone"
        >
          <a-input
            placeholder="可输入11位数字"
            v-model="form.phone"
            allowClear
            type="number"
            @keydown="handleNumber"
            @blur="handleNumber"
          ></a-input>
        </a-form-model-item>

        <a-form-model-item
          label="验证码"
          prop="verifyCode"
        >
          <a-input
            placeholder="可输入6位数字"
            v-model="form.verifyCode"
            type="number"
            @keydown="handleNumber"
            @blur="handleNumber"
          >
            <template #suffix>
              <span
                class="verify-code-text"
                @click.stop="getVerifyCode"
              >
                <a v-if="!timeShow">获取验证码</a>
                <a v-else>已发送({{timeCount}}S)</a>
              </span>
            </template>
          </a-input>
        </a-form-model-item>
      </a-form-model>
      <!-- 操作按钮 -->
      <a-row
        type="flex"
        justify="end"
        :gutter="20"
        class="operate-btn-group"
      >
        <a-col>
          <a-button @click="handleCancel">取消</a-button>
        </a-col>
        <a-col>
          <a-button
            type="primary"
            @click="handleOk"
          >确认</a-button>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import {
  getVerifyCode as getVerifyCodeApi,
  modifyPhone as modifyPhoneApi,
  validatePhone as validatePhoneApi
} from '@/api/personal.js'
import { awaitWrap } from '@/utils/await-wrap.js'
import { handleOnlyNumber } from '@/utils'
export default {
  data () {
    return {
      phoneModalVisible: false,
      form: {
        id: '',
        phone: "",
        verifyCode: ""
      },
      tempForm: '',
      rules: {
        phone: [
          { required: true, message: "手机号必须填写" },
          {
            validator: async (rule, value, callback) => {
              if (!/^1\d{10}$/.test(value)) {
                return Promise.reject(new Error("请输入11位纯数字号码"))
              } else {
                let { phone } = this.form
                const [res, err] = await awaitWrap(validatePhoneApi({ id: this.userId, phone }))

                if (err) return Promise.reject(new Error(err))
                if (res.code === 1000) {
                  return Promise.resolve()
                } else if (res.code === 9010) {
                  return Promise.reject(new Error("该手机号码已存在"))
                } else {
                  return Promise.reject(new Error(res.message))
                }
              }
            }, trigger: 'blur'
          }
        ],
        verifyCode: [
          { required: true, message: "验证码必须填写" },
          {
            validator: (rule, value) => {
              if (/^\d{6}$/.test(value)) {
                return Promise.resolve();
              } else {
                return Promise.reject(new Error("请输入6位纯数字验证码"));
              }
            },
            trigger: "blur",
          },
        ],
      },
      // 验证码
      timeShow: false,
      timeCount: 60,
      timer: null
    }
  },
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: ''
  },
  methods: {
    handleNumber (evt) {
      handleOnlyNumber(evt)
    },
    getVerifyCode () {
      if (this.sendingCode === true || this.timeShow === true) return
      this.$refs.formRef.validateField('phone', (errorMessage) => {
        if (errorMessage) return
        let { phone } = this.form
        const { projectId } = JSON.parse(localStorage.getItem('projectInfo'))
        const MAX_COUNT = 60 // 验证码获取时间间隔

        this.sendingCode = true
        getVerifyCodeApi({
          phone,
          projectId
        }).then(res => {
          this.sendingCode = false
          if (res.code === 1000) {
            // 倒计时
            this.timeShow = true
            this.timeCount = MAX_COUNT
            this.timer = setInterval(() => {
              if (this.timeCount > 0 && this.timeCount <= MAX_COUNT) {
                this.timeCount--
              } else {
                clearInterval(this.timer)
                this.timeShow = false
                this.timeCount = MAX_COUNT
              }
            }, 1000)
          } else {
            this.$message.warning(res.message)
            this.timeShow = false
            this.timeCount = MAX_COUNT
          }
        }).catch(err => {
          this.sendingCode = false

          this.timeShow = false
          this.timeCount = MAX_COUNT
          console.log('err', err)
        })
      })
    },
    handleOk () {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          let { phone, verifyCode } = this.form
          modifyPhoneApi({
            phone,
            msgCode: verifyCode
          }).then((res) => {
            if (res.code === 1000) {
              this.$message.success('修改成功')

              this.timeShow = false
              this.$emit('toggleModalType', 'personalInfo')
              this.$emit('updatePhone', phone)
            } else {
              this.$message.error(res.message)
            }
          }).catch(err => {
            console.log('err', err)
          })
        } else {
          this.$message.warning('信息填写不准确')
          return false
        }
      })
    },
    // 关闭当前弹窗
    handleClose () {
      this.$emit('closeModal')
    },
    handleCancel () {
      this.$emit('toggleModalType', 'personalInfo')
      this.$refs.formRef.resetFields()
      this.timeShow = false
    },
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
}
</script>

<style lang="less" scoped>
.modify-phone-form {
  .verify-code-text {
    color: @link-color;
    display: inline-block;
    height: 30px;
    line-height: 30px !important;
    color: @link-color;
    cursor: pointer;
    border-radius: 4px;
  }
}
.operate-btn-group {
  margin-top: 100px;
  button {
    width: 104px;
    height: 40px;
  }
}
</style>
<style lang="less">
.modify-phone-modal {
  .house-modal-content {
    width: 492px;
    // height:717px;
  }
}
</style>
